import { API_BASE_URL, HEADERS_WITH_TOKEN } from "./BaseUrl";

export const getPropertyAmenities = () =>
  fetch(
    `${API_BASE_URL}/property-amenities`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN
    }
  )
  .then(res => res.json())


export const savePropertyAmenity = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/property-amenities`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN,
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const editPropertyAmenity = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/property-amenities/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN,
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const deletePropertyAmenity = async (id) => {
  const res = await fetch(
    `${API_BASE_URL}/property-amenities/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN
    }
  )
  return await res.json()
}